import React, { useCallback, useMemo } from 'react';
import { Loader } from '@ui';
import { Checkbox } from '@ui/molecules/inputs/Checkbox';
import { translate } from '@utils/i18n';
import useAIInspectionManager from '../../hooks/useAIInspectionManager';
import useUpdateAIInspectionManager from '../../hooks/useUpdateAIInspectionManager';
import './OfficeOnlyTabStyles.scss';
const namespace = 'features.settings.ai_inspection_manager.office_only';
function OfficeOnlyTab() {
    var _a;
    const { data: settings, isLoading } = useAIInspectionManager();
    const { updateSettings } = useUpdateAIInspectionManager();
    const advancedSettings = useMemo(() => {
        var _a, _b;
        const apiSettings = settings === null || settings === void 0 ? void 0 : settings.aiInspectionManagerOfficeOnlyAdvancedSettings;
        return {
            autoResolveUnresolvedDeficiencies: (_a = apiSettings === null || apiSettings === void 0 ? void 0 : apiSettings.autoResolveUnresolvedDeficiencies) !== null && _a !== void 0 ? _a : false,
            autoCompleteOnTechResolve: (_b = apiSettings === null || apiSettings === void 0 ? void 0 : apiSettings.autoCompleteOnTechResolve) !== null && _b !== void 0 ? _b : false
        };
    }, [settings === null || settings === void 0 ? void 0 : settings.aiInspectionManagerOfficeOnlyAdvancedSettings]);
    const handleUpdateSettings = useCallback((updatedSettings) => {
        if (!settings)
            return;
        updateSettings.mutate({
            settingsUpdate: Object.assign(Object.assign({}, settings), { aiInspectionManagerOfficeOnlyAdvancedSettings: updatedSettings })
        });
    }, [settings, updateSettings]);
    const handleCheckboxChange = useCallback((field, value) => {
        handleUpdateSettings(Object.assign(Object.assign({}, advancedSettings), { [field]: value }));
    }, [advancedSettings, handleUpdateSettings]);
    if (isLoading) {
        return (React.createElement("div", { style: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' } },
            React.createElement(Loader, { size: "48", title: "Loading", vertical: true })));
    }
    return (React.createElement("div", { className: "office-only-tab main-section-container" },
        React.createElement("div", { className: "advanced-settings-section" },
            React.createElement("h3", { className: "advanced-settings-section__title" },
                translate('section_title', { namespace }),
                React.createElement("div", { className: "advanced-settings-section__title-line" })),
            React.createElement("div", { className: "advanced-settings-section__checkbox" },
                React.createElement(Checkbox, { id: "auto-resolve-unresolved-deficiencies", label: translate('auto_resolve_label', { namespace }), description: translate('auto_resolve_description', { namespace }), checked: advancedSettings.autoResolveUnresolvedDeficiencies, onChange: (checked) => handleCheckboxChange('autoResolveUnresolvedDeficiencies', checked) })),
            React.createElement("div", { className: "advanced-settings-section__checkbox" },
                React.createElement(Checkbox, { id: "auto-complete-on-tech-resolve", label: translate('auto_complete_on_tech_resolve_label', { namespace }), description: translate('auto_complete_on_tech_resolve_description', { namespace }), checked: (_a = advancedSettings.autoCompleteOnTechResolve) !== null && _a !== void 0 ? _a : false, onChange: (checked) => handleCheckboxChange('autoCompleteOnTechResolve', checked) })))));
}
export default OfficeOnlyTab;
